// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-list[data-v-2362af70] {\n  border: 1px solid #e8eef1;\n  border-radius: 3px;\n}", ""]);
// Exports
module.exports = exports;
